import { render, staticRenderFns } from "./AdminHumanResources.vue?vue&type=template&id=60808cb2&scoped=true&"
import script from "./AdminHumanResources.vue?vue&type=script&lang=js&"
export * from "./AdminHumanResources.vue?vue&type=script&lang=js&"
import style0 from "./AdminHumanResources.vue?vue&type=style&index=0&id=60808cb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60808cb2",
  null
  
)

export default component.exports